export default {
	messages: {
		required: (field) => `Este campo es requerido`,
		length: (field) => `El campo está mal formado`,
		alpha_spaces : (field) => `El campo solo permite carácteres alfabéticos`,
		email : (field) => `El campo email está mal formado`,
		min : (field) => `El campo está mal formado`,
	},
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		email_firmante : {
			email : 'Debes indicar una dirección de correo electrónico válida'	
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		nombre : {
			required : 'El campo nombre es obligatorio'
		},
		mensaje : {
			required : 'El campo mensaje es obligatorio'
		},
		apellidos : {
			required : 'El campo apellidos es obligatorio'
		},
		cif : {
			required : 'El campo cif es obligatorio',
			length : 'El campo cif está mal formado',
		},
		nombre_usuario : {
			required : 'El campo nombre de usuario es obligatorio'
		},
		puesto : {
			required : 'El campo puesto es obligatorio'
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		telefono_empresa : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		telefono2 : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		sede : {
			required : 'El campo sede es obligatorio'
		},
		experiencia : {
			required : 'El campo experiencia es obligatorio'
		},
		password : {
			required : 'El campo contraseña es obligatorio',
			min : 'La contraseña debe tener al menos 6 carácteres',
			confirmed : 'Las contraseñas no coinciden'
		},
		password2 : {
			required : 'El campo contraseña es obligatorio',
			min : 'La contraseña debe tener al menos 6 carácteres',
			confirmed : 'Las contraseñas no coinciden'
		},
		politica : {
			required : 'Debes aceptar la política de privacidad'
		},
		direccion : {
			required : 'El campo direccion es obligatorio'
		},
		cp : {
			required : 'El campo código postal es obligatorio'
		},
		pais : {
			required : 'El campo país es obligatorio'
		},
		file : {
			size : 'El tamaño maximo son 2MB',
			mimes : 'El formato debe ser PDF'
		},

		titulo : {
			required : 'El campo nombre de la oferta es obligatorio'
		},
		plazas : {
			required : 'El campo numero de plazas es obligatorio'
		},
		poblacion : {
			required : 'El campo población es obligatorio'
		},
		provincia : {
			required : 'El campo provincia es obligatorio'
		},
		horario : {
			required : 'El campo horario de trabajo es obligatorio'
		},
		calificacion: {
			regex: 'El valor debe ser un número entre 0-10 , puede contener decimales'
		},
		horasAldia : {
			required : 'El campo horas al día es obligatorio',
			numeric : 'El campo ayuda al estudio debe ser un valor numérico'
		},
		ayudaEstudio : {
			required : 'El campo ayuda al estudio es obligatorio',
			numeric : 'El campo horas al día debe ser un valor numérico'
		},
		salario : {
			required : 'El campo renmuneración es obligatorio'
		},
		remuneraciones : {
			required : 'El campo otras remuneraciones es obligatorio'
		},
		contrato : {
			required : 'El campo tipo de contrato es obligatorio'
		},
		descripcion : {
			required : 'El campo descripcion es obligatorio'
		},
		curso : {
			required : 'El campo curso es obligatorio'
		},
		titulacion : {
			required : 'El campo titulación es obligatorio'
		},
		puestoTrabajo : {
			required : 'El campo puesto de trabajo es obligatorio'
		},
		horasDia : {
			required : 'El campo horas al día es obligatorio'
		},
		departamento : {
			required : 'El campo departamento es obligatorio'
		},
		nombreTutorEmpresa : {
			required : 'El campo nombre del tutor de la empresa es obligatorio'
		},
		ApellidosTutorEmpresa : {
			required : 'El campo apellidos del tutor de la empresa es obligatorio'
		},
		emailTutorEmpresa : {
			required : 'El campo email del tutor de la empresa es obligatorio',
			email : 'El campo email del tutor de la empresa está mal formado'
		},
		nombreTutorUni : {
			required : 'El campo nombre del tutor de la universidad es obligatorio'
		},
		tareasAdesarrollar : {
			required : 'El campo tareas a desarrollar es obligatorio'
		},
		nombreFiscal : {
			required : 'El campo nombre fiscal es obligatorio'
		},
		nombreComercial : {
			required : 'El campo nombre comercial es obligatorio'
		},
		codigo_postal : {
			required : 'El campo código postal es obligatorio'
		},
		area_funcional : {
			required : 'El campo área funcional es obligatorio'
		},
		nombre_comercial : {
			required : 'El campo nombre comercial es obligatorio'
		},
		nombre_fiscal : {
			required : 'El campo nombre fiscal es obligatorio'
		},
		observacion : {
			required : 'El campo observación es obligatorio'
		},
		motivorechazo : {
			required : 'El campo motivo del rechazo es obligatorio'
		},
		nombredocumentacion : {
			required : 'El campo nombre de la documentación es obligatorio'
		},
		file : {
			required : 'El archivo adjunto es obligatorio',
			mimes : 'Este formato no esta permitido'
		},
		iban : {
			required : "El campo cuenta bancaria es obligatorio",
			length: "Revisa que están correctos todos los números de tu cuenta.",
			checkiban : "El IBAN está mal formado"
		},
		dni : {
			checkDNI : "El DNI está mal formado"
		},

	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js